import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { SubmitHandler, useForm } from "react-hook-form";
import { TextField, IconButton, Box, useTheme } from "@mui/material";
import { Search as SearchIcon, Clear as ClearIcon } from "@mui/icons-material";

import { formConfig } from "./formConfig";
import {
  clearBtnStyles,
  formStyles,
  getInputFieldStyles,
  getSubmitBtnStyles,
} from "./styles";

const SearchBar = () => {
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Search bar form control
  const { reset, handleSubmit, register, watch, setValue } =
    useForm<ISearch>(formConfig);
  const isNotEmpty = !!watch().search;

  useEffect(() => {
    const search = searchParams?.get("search");
    if (search) {
      setValue("search", search);
    }
  }, []);

  const onSearchSubmit: SubmitHandler<ISearch> = (data) => {
    if (data.search) {
      navigate(`?search=${data.search}`);
    } else {
      navigate(``);
    }
  };

  const handleClearSearch = () => {
    reset();
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(onSearchSubmit)}
      sx={formStyles}
    >
      <TextField
        name="search"
        placeholder="Search for answers..."
        variant="outlined"
        sx={getInputFieldStyles(theme)}
        InputProps={{
          endAdornment: (
            <>
              {isNotEmpty && (
                <IconButton onClick={handleClearSearch} sx={clearBtnStyles}>
                  <ClearIcon />
                </IconButton>
              )}
            </>
          ),
        }}
        inputProps={{
          ...register("search"),
          style: {
            WebkitAppearance: "none",
            WebkitBorderRadius: "10px",
          },
        }}
      />

      <IconButton type="submit" color="primary" sx={getSubmitBtnStyles(theme)}>
        <SearchIcon color="inherit" />
      </IconButton>
    </Box>
  );
};

export default SearchBar;
